/**
 * Channel Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SiblingSkuVO } from './siblingSkuVO';


/**
 * Online sku detail that has been saved or published online
 */
export interface OnlineSkuDetailVO { 
    /**
     * ID
     */
    id?: number;
    /**
     * ID of SPU in warehouse
     */
    spuId?: number;
    /**
     * ID of SKU in warehouse
     */
    skuId?: number;
    /**
     * Code of SKU in warehouse
     */
    skuCode?: string;
    /**
     * Category ID of online product
     */
    categoryId?: number;
    /**
     * Name of online product
     */
    name?: string;
    /**
     * Description of online product
     */
    description?: string;
    /**
     * Sale price of online sku
     */
    price?: number;
    /**
     * Status of sku: DRAFT, ACTIVE, INACTIVE
     */
    status?: OnlineSkuDetailVO.StatusEnum;
    /**
     * Map of attributes of online product
     */
    attributes?: { [key: string]: string; };
    /**
     * Main image for online product
     */
    mainImage?: string;
    /**
     * List of detail images for online product
     */
    detailImages?: Array<string>;
    /**
     * Quantity available on Lazada
     */
    lazadaQuantity?: number;
    /**
     * Sellable quantity on Lazada
     */
    lazadaSellableQuantity?: number;
    /**
     * Sibling (variation) skus that have been published, with price and platform quantity
     */
    siblings?: Array<SiblingSkuVO>;
}
export namespace OnlineSkuDetailVO {
    export const StatusEnum = {
        Draft: 'DRAFT',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE',
        DraftPublished: 'DRAFT_PUBLISHED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


